import { useMemo } from 'react'
import { Divider, Stack, StackProps, Typography } from '@mui/material'
import { SisetuResult } from "interface/sisetu"

import {
	Domain as MatchIcon,
	DomainAdd as MultiHitIcon,
	Error as MayBeIcon,
	Help as UnableIcon,
	Clear as NotFoundIcon
} from '@mui/icons-material'

import { matchingScoreToState } from '../types'
import { flatJoin } from 'shared/util'

type SisetuMatchingCandidateProps = {
	sisetu: SisetuResult
	isMultiHit: boolean
} & StackProps
export const SisetuMatchingCandidate = ({
	sisetu,
	isMultiHit,
	...others
}: SisetuMatchingCandidateProps) => {
	const state = useMemo(
		() => matchingScoreToState(100, isMultiHit),
		[isMultiHit]
	)
	const { textColor, icon } = useMemo(
		() => {
			if (state === "match") return { textColor: "primary", icon: <MatchIcon color="success"/> }
			if (state === "multiHit") return { textColor: "default", icon: <MultiHitIcon color="secondary"/> }
			if (state === "maybe") return { textColor: "default", icon: <MayBeIcon color="warning"/> }
			if (state === "unable") return { textColor: "default", icon: <UnableIcon color="error"/> }
			return { textColor: "disabled", icon: <NotFoundIcon color="disabled"/> }
		},
		[state]
	)
	return (
		<Stack
			alignItems="flex-start"
			direction="row"
			spacing={1}
			justifyContent="flex-start"
			overflow="hidden"
			{...others}
		>
			{icon}
			<Stack
				direction="column"
				justifyContent="flex-start"
				overflow="hidden"
				flexGrow={1}
			>
				<Stack direction="row" spacing={1} alignItems="flex-start">
					<Stack flexGrow={1} direction="row" spacing={1} alignItems="center" flexWrap="wrap">
						<Typography variant="body1" color={textColor}>{sisetu.sisetuName}</Typography>
						{(sisetu.keieitai?.name || sisetu.bedCount?.ippan) ? (
							<Typography variant="body2" color="text.secondary">（{
								flatJoin(
									' ',
									sisetu.keieitai?.name,
									sisetu.bedCount?.ippan ? `${sisetu.bedCount.ippan}床` : null
								)
							}）</Typography>
						) : <></>}
					</Stack>
					<Typography variant="caption" color={textColor}>{sisetu.sisetuCode}</Typography>
				</Stack>
				
				{sisetu.juusyo ? (
					<>
						<Divider sx={{ marginY: 0.5 }}/>
						<Typography variant="body2" color={textColor}>{sisetu.juusyo}</Typography>
					</>
				) : <></>}
			</Stack>
		</Stack>
	)
}
